import { DialogProps, Dialog, styled } from '@mui/material';

export const DialogStyled = styled(Dialog)<DialogProps>(({ theme }) => ({
  '& .MuiDialog-paper.MuiPaper-root': {
    margin: theme.spacing(4),
    padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1),
      padding: theme.spacing(2),
    },
  },
}));
